import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Link } from "@reach/router";
import { useQuery } from "@apollo/client";
import { getViewer } from "types/gql-types";
import { VIEWER_QUERY } from "../auth/query";
import Navigation, { ProfileButton } from "./navigation";
import HamburgerMenu from "./layout/menu";
import stylesFunc from "./styles";

const useStyles = makeStyles(stylesFunc);

const Header: React.FC<{short?: boolean}> = ({ short = false }) => {
  const { data, error } = useQuery<getViewer>(VIEWER_QUERY);
  if (error) return <div>Error loading user</div>;
  const classes = useStyles();

  return (
    <>
      <AppBar position="static" color="secondary" className={`${classes.appBar} ${!short && classes.appBarFull}`}>
        <Toolbar>
          <Link to="/">
            <div className="header-logo-image" />
          </Link>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <Navigation viewer={data?.viewer}/>
          </div>
          <div className={classes.sectionMobile}>
            <ProfileButton viewer={data?.viewer}/>
            <HamburgerMenu viewer={data?.viewer}/>
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
